module.exports = __webpack_public_path__ + "img/individual-150x150.ae48fa9f.png";